import { createFAsomeStore } from '@apia/dom-store';
import { ReactNode, useCallback, useMemo } from 'react';
import { distinctors } from './distinctors';
import { operations } from './operations';
import { keysMakers } from './keysMaker';
import { getInitialState } from './state';
import { StoreContext, TStoreContext } from './context';
import { TState } from './types';

export const useStore = ({
  storeId,
}: Pick<TState, 'storeId'>): [
  TStoreContext['actions'],
  TStoreContext['useProps'],
  TStoreContext['getState'],
  TStoreContext['registerStateChangeListener'],
  ({ children }: { children: ReactNode }) => JSX.Element,
] => {
  const [actions, useProps, getState, registerStateChangeListener] = useMemo(
    () =>
      createFAsomeStore({
        initialState: getInitialState({
          storeId,
        }),
        distinctors,
        keysMakers,
        operations,
      }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  const ContextProvider = useCallback(
    ({ children }: { children: ReactNode }) => {
      return (
        <StoreContext.Provider
          value={{
            actions,
            useProps,
            getState,
            registerStateChangeListener,
          }}
        >
          {children}
        </StoreContext.Provider>
      );
    },
    [actions, getState, registerStateChangeListener, useProps],
  );

  return [
    actions,
    useProps,
    getState,
    registerStateChangeListener,
    ContextProvider,
  ];
};
